import {
  GET_ALL_WARD,
  GET_WARD_TO,
  GET_WARD_FROM,
  SET_LOADED_WARD_BY_DISTRICT_CODE,
  SET_LOADED_WARD_BY_DISTRICT_ID,
  GET_WARD
} from 'src/store/mutation-types'
export default {
  [GET_ALL_WARD] (state, wards) {
    state.wards = wards
  },
  [GET_WARD_TO] (state, wards) {
    state.wardTo = wards
  },
  [GET_WARD_FROM] (state, wards) {
    state.wardFrom = wards
  },
  [SET_LOADED_WARD_BY_DISTRICT_CODE] (state, params) {
    state.wardsByDistrictCode[params.city_code] = params.wards
  },
  [SET_LOADED_WARD_BY_DISTRICT_ID] (state, params) {
    state.wardsByDistrictId[params.city_id] = params.wards
  },
  [GET_WARD] (state, ward) {
    state.ward = ward
  }
}



// WEBPACK FOOTER //
// ./src/components/ward/store/mutations.js